import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MenuService } from '../../notifications/modals/menu.service';
import { NotificationInfo } from '../../notifications/store/models';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class NotificationsComponent {
    @Input() notifications: NotificationInfo[];

    constructor(
        public modalsService: MenuService, // used in template
    ) {}

}
